import { Component } from '@angular/core';

@Component({
  selector: 'app-corporate-reports-trends',
  templateUrl: './corporate-reports-trends.component.html',
  styleUrl: './corporate-reports-trends.component.scss'
})
export class CorporateReportsTrendsComponent {

}
